const close = `Fermer`
export default {
    BAlert: {
        dismissLabel: close,
    },
    BButtonClose: {
        ariaLabel: close,
    },
    BCarousel: {
        labelPrev: 'Slide précedente',
        labelNext: 'Slide suivante',
        labelGotoSlide: 'Aller à la slide',
        labelIndicators: 'Séléctionnez une slide à afficher',
    },
    BDropdown: {
        toggleText: 'Basculer menu déroulant',
    },
    BFormFile: {
        browseText: 'Parcourir',
        placeholder: 'Aucun fichier choisi',
        dropPlaceholder: 'Glissez vos fichiers ici',
    },
    BModal: {
        cancelTitle: 'Annuler',
        okTitle: 'OK',
        headerCloseLabel: close,
    },
    BNavbarToggle: {
        label: 'Basculer navigation',
    },
    BCalendar : {
        labelPrevYear: 'Année précedente',
        labelPrevMonth: 'Mois précedent',
        labelCurrentMonth: 'Ce mois ci',
        labelNextMonth: 'Mois suivant',
        labelNextYear: 'Année suivante',
        labelToday: `Aujourd'hui`,
        labelSelected: 'Date séléctionnée',
        labelNoDateSelected: 'Aucune date séléctionnée',
        labelCalendar: 'Calendrier',
        labelNav: 'Naviger dans le calendrier',
        labelHelp: 'Utilisez les flèches du clavier pour naviger dans les dates',
    },
    BTime : {
        labelHours: 'Heures',
        labelMinutes: 'Minutes',
        labelSeconds: 'Secondes',
        labelIncrement: 'Augmenter',
        labelDecrement: 'Réduire',
        labelSelected: 'Heure séléctionnée',
        labelNoTimeSelected: 'Aucune',
        labelCloseButton: 'Fermer',
    },
}
